export const MAIL_CONFIG = 'hello@theotherlab.co';
